import React from 'react';
import {
    Switch,
    Route,
    Redirect
  } from "react-router-dom";

import MainBody from './MainBody';
import NationalBody from './NationalBody';

function Container({location}){
    return (
        <div className="custom_bodycontainer__mainpage">
            <Switch>
            <Route exact path="/">
            <Redirect to="/home" />
            </Route>
            <Route exact path="/home">
            <MainBody />
            </Route>
            <Route exact path="/national-news">
            <NationalBody />
            </Route>
            </Switch>
        </div>
    
    );
}

export default Container;